import { fetchAuthSession } from "aws-amplify/auth";
import { post, put } from "aws-amplify/api";
import { useMutation, useQueryClient } from "react-query";

export const useProfileContactPostMutation = (id) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (profileContactFormInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: "pcmedapi",
        path: "/profile/contact/" + id,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: profileContactFormInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["profileContactData"] });
    },
  });
};

export const useProfileContactPutMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (profileContactFormInputs) => {
      const session = await fetchAuthSession();
      const { body } = await put({
        apiName: "pcmedapi",
        path: "/profile/contact",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: profileContactFormInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["profileContactData"] });
    },
  });
};
